import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { VoiceAgentBootstrap } from '../api/voiceAgentApi';
import { AIInterviewInterface, VoiceAgentInterviewInterface } from '../features/interview';
import { resolveUseVoiceAgent } from '../features/interview/utils/resolveUseVoiceAgent';
import DotGrid from '../components/common/DotGrid';
import OnboardingLogoutButton from '../components/auth/OnboardingLogoutButton';
import './Interview.css';

interface LocationState {
  isOnboarding?: boolean;
  sessionId?: string;
  aiSessionId?: string;
  firstQuestion?: string;
  audioUrl?: string;
  audioMode?: string;
  maxQuestions?: number;
  voiceAgentBootstrap?: VoiceAgentBootstrap;
}

const Interview: React.FC = () => {
  const location = useLocation();
  const state = location.state as LocationState | null;
  const isOnboarding = state?.isOnboarding ?? false;
  const voiceAgentBootstrap = state?.voiceAgentBootstrap;

  const roundSession = useMemo(() => {
    if (voiceAgentBootstrap) {
      return undefined;
    }
    if (state?.sessionId && state?.firstQuestion) {
      return {
        sessionId: state.sessionId,
        aiSessionId: state.aiSessionId,
        firstQuestion: state.firstQuestion,
        audioUrl: state.audioUrl,
        audioMode: state.audioMode,
        maxQuestions: state.maxQuestions,
      };
    }
    return undefined;
  }, [
    voiceAgentBootstrap,
    state?.sessionId,
    state?.firstQuestion,
    state?.aiSessionId,
    state?.audioUrl,
    state?.audioMode,
    state?.maxQuestions,
  ]);

  const useVoiceAgent = resolveUseVoiceAgent(isOnboarding);

  return (
    <div className="interview-page">
      {isOnboarding && <OnboardingLogoutButton />}
      <div className="interview-aurora-background">
        <DotGrid />
      </div>
      {useVoiceAgent ? (
        <VoiceAgentInterviewInterface
          isOnboarding={isOnboarding}
          voiceAgentBootstrap={voiceAgentBootstrap}
        />
      ) : (
        <AIInterviewInterface isOnboarding={isOnboarding} roundSession={roundSession} />
      )}
    </div>
  );
};

export default Interview;
